import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[620px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20dramatic%20and%20artistic%20manga%20style%20illustration%20with%20warm%20crimson%20and%20deep%20amber%20gradients%2C%20abstract%20ink%20wash%20textures%20blending%20with%20modern%20digital%20elements%2C%20floating%20manga%20panels%20and%20Japanese%20wave%20patterns%20in%20the%20background%2C%20elegant%20traditional%20aesthetic%20merged%20with%20contemporary%20design%2C%20soft%20golden%20light%20radiating%20from%20the%20center%2C%20atmospheric%20and%20cinematic%20composition&width=1800&height=900&seq=jmtt-hero-bg-01&orientation=landscape"
          alt="禁漫天堂 - 漫画阅读平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full text-center px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-5">
            禁漫天堂 — 畅享极致
            <br />
            漫画阅读体验
          </h1>
          <p className="text-base md:text-lg text-background-200/90 mb-8 max-w-xl mx-auto leading-relaxed">
            海量正版漫画资源 · 安全稳定访问 · 高清流畅阅读
            <br />
            官方入口导航，一站式漫画服务平台
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#"
              className="bg-primary-500 text-background-50 dark:text-foreground-950 px-8 py-3.5 rounded-full text-base font-semibold whitespace-nowrap hover:bg-primary-600 transition-all duration-200 transform hover:scale-105"
            >
              立即访问官方入口
            </a>
            <Link
              to="/category"
              className="border-2 border-background-50/60 text-background-50 px-8 py-3.5 rounded-full text-base font-medium whitespace-nowrap hover:bg-background-50/15 transition-all duration-200"
            >
              浏览漫画分类
            </Link>
          </div>
        </div>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-4 max-w-3xl mx-auto">
          {[
            { value: '50,000+', label: '正版漫画' },
            { value: '1,200万+', label: '注册用户' },
            { value: '99.9%', label: '服务可用率' },
            { value: '24/7', label: '客服支持' },
          ].map((stat, i) => (
            <div key={i} className="bg-background-50/10 backdrop-blur-sm rounded-lg py-4 px-4">
              <div className="text-xl md:text-2xl font-heading font-bold text-accent-500">{stat.value}</div>
              <div className="text-xs md:text-sm text-background-200 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}